// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"85bf48b7","99":"dc762414","288":"dc762414","309":"dc762414","351":"85bf48b7","815":"85bf48b7"}[chunkId] + ".chunk.css";
};